import React from 'react';
import { FadeIn, Section } from './ui';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'El Blindaje MAI/PPI',
    desc: 'Plantillas legales listas para adaptar tus evaluaciones a alumnos con TEA, TDAH o discalculia en 5 minutos. Con respaldo pedagógico internacional. El documento que te protege ante directivos, padres e inspectores.',
    value: 'USD 6,20'
  }, {
    title: 'ChatGPT para Profes de Matemática',
    desc: '25 prompts listos para copiar y pegar que generan ejercicios, guías, rúbricas y explicaciones en menos de 60 segundos. Nunca más perdás horas buscando materiales en internet.',
    value: 'USD 5,60'
  }, {
    title: 'La Planilla Maestra de Notas',
    desc: 'Sistema en Google Sheets con fórmulas automáticas que calcula promedios, detecta alumnos en riesgo y te avisa antes de que sea tarde. Gestión de 200 alumnos en 15 minutos semanales.',
    value: 'USD 4,90'
  }, {
    title: 'Pack de Plantillas de Seguimiento de Alumnos',
    desc: 'Detectá rápido quién está flojo, quién mejoró y quién necesita ayuda antes de desaprobar. Incluye fichas, semáforos y registros visuales para hacer seguimiento sin perder tiempo entre papeles sueltos.',
    value: 'USD 4,20'
  }, {
    title: 'Plantillas de Exámenes Recuperatorios',
    desc: 'Armá recuperatorios, segundas instancias y evaluaciones para ausentes en minutos. Incluye formatos listos, estructuras reutilizables y modelos para no volver a improvisar otro examen desde cero.',
    value: 'USD 4,20'
  }, {
    title: 'Pack de Plantillas de Organización Semanal Docente',
    desc: 'Ordená tus cursos, clases, pendientes y materiales en una sola hoja. Un sistema visual para bajar la ansiedad del domingo y arrancar la semana con todo claro, sin caos mental ni olvidos.',
    value: 'USD 3,50'
  }];
  return <Section variant="dark" data-id="element-36">
      <FadeIn data-id="element-37">
        <h2 className="text-[28px] md:text-4xl font-black text-brand-green mb-2 text-center" data-id="element-38">
          Y eso no es todo. También recibís estos 6 Regalos:
        </h2>
        <p className="text-gray-600 text-center mb-12 text-lg" data-id="element-39">
          Incluidos sin costo adicional en tu compra
        </p>
      </FadeIn>

      <div className="space-y-6" data-id="element-40">
        {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-41">
            <div className="bg-gray-50 border border-brand-gold/40 p-6 md:p-8 rounded-2xl relative hover:border-brand-gold transition-colors duration-300 shadow-sm" data-id="element-42">
              <div className="inline-flex items-center gap-2 bg-brand-gold/10 text-brand-gold text-xs font-bold px-3 py-1.5 rounded-full mb-4 border border-brand-gold/20" data-id="element-43">
                <Gift size={14} data-id="element-44" />
                <span data-id="element-45">BONUS {i + 1} — GRATIS</span>
              </div>

              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3" data-id="element-46">
                {bonus.title}
              </h3>

              <p className="text-gray-600 text-base leading-relaxed mb-4" data-id="element-47">
                {bonus.desc}
              </p>

              <div className="text-sm text-gray-500 font-medium" data-id="element-48">
                Valor: <span className="line-through" data-id="element-49">{bonus.value}</span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}